import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const submitRegistration = async (values) => {
  const formData = new FormData();

  Object.entries(values).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (key === 'selectedCourses') {
      formData.append(key, JSON.stringify(value));
      return;
    }

    formData.append(key, value);
  });

  const response = await axios.post(`${API_BASE_URL}/registrations`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
};

export const fetchRegistrations = async (adminToken) => {
  const response = await axios.get(`${API_BASE_URL}/registrations`, {
    headers: {
      'x-admin-token': adminToken
    }
  });

  return response.data.registrations;
};

export const fetchAdminDashboard = async (adminToken) => {
  const response = await axios.get(`${API_BASE_URL}/registrations/admin/dashboard`, {
    headers: {
      'x-admin-token': adminToken
    }
  });

  return response.data.stats;
};

export const fetchAdminPrograms = async (adminToken) => {
  const response = await axios.get(`${API_BASE_URL}/registrations/admin/programs`, {
    headers: {
      'x-admin-token': adminToken
    }
  });

  return response.data.programs;
};

export const fetchAdminProgramStudents = async (programId, adminToken) => {
  const response = await axios.get(
    `${API_BASE_URL}/registrations/admin/programs/${encodeURIComponent(programId)}/students`,
    {
      headers: {
        'x-admin-token': adminToken
      }
    }
  );

  return response.data;
};

export const createRegistrationPaymentCode = async (registrationId, courseIdsToPay = []) => {
  const response = await axios.post(
    `${API_BASE_URL}/payments/registrations/${registrationId}/payment-code`,
    { courseIdsToPay }
  );

  return response.data.payment;
};

export const syncRegistrationPayment = async (paymentId, adminToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/payments/${paymentId}/sync`,
    {},
    {
      headers: {
        'x-admin-token': adminToken
      }
    }
  );

  return response.data.payment;
};

export const fetchRegistrationPaymentStatus = async (paymentId) => {
  const response = await axios.get(`${API_BASE_URL}/payments/${paymentId}/status`);

  return response.data.payment;
};

export const fetchRegistrationCoursesForPayment = async (registrationNumber) => {
  const response = await axios.get(
    `${API_BASE_URL}/payments/registrations/${encodeURIComponent(registrationNumber)}/courses`
  );

  return response.data;
};

export const createCoursePaymentCode = async (registrationNumber, courseIdsToPay = []) => {
  const response = await axios.post(
    `${API_BASE_URL}/payments/registrations/${encodeURIComponent(registrationNumber)}/course-payment-code`,
    { courseIdsToPay }
  );

  return response.data.payment;
};
